import moment from "moment";

/*
 * A consultation's `created`, as GET .../consultation/get/{id} sends it: day-first,
 * "06-05-2026 12:21". It comes from the shared entity base class, which KIN-2174's ISO
 * migration did not reach, so it may still move to ISO; both shapes are read, strictly, so
 * neither can be mistaken for the other.
 *
 * dayjs(created) without a format reads it month-first (6 May as "05 Jun", any day after
 * the 12th as Invalid Date), and dayjs(created, "DD-MM-YYYY HH:mm") would turn Invalid the
 * day the field becomes ISO (KIN-2181).
 */
const CREATED_FORMATS = ["DD-MM-YYYY HH:mm", "DD-MM-YYYY HH:mm:ss", moment.ISO_8601];

export const formatConsultationCreated = (created) => {
  if (!created) return "";

  const parsed = moment(created, CREATED_FORMATS, true);

  return parsed.isValid() ? parsed.format("DD MMM YYYY HH:mm") : "";
};
